module.exports = __webpack_public_path__ + "media/images/warning_icon-5a9ec0d58a73db20cb8aacc844818f77.png";